(function () {
  var headingSelector = 'h2, h3, p';
  var staticHeadingText = 'shipping';
  var lastUpdatedText = 'last updated:';
  var productionTimingText = 'we currently ship within';
  var productionTimingPreviousText = 'be noted on the product page.';
  var additionalProductionTimeText = 'some products may require additional time.';
  var additionalProductionTimePreviousText = 'before shipping';

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isAccordionStartText(text) {
    return (
      text.indexOf('processing') === 0 &&
      text.indexOf('production') !== -1 &&
      text.indexOf('time') !== -1
    );
  }

  function getPolicyBody() {
    return (
      document.querySelector('.shopify-policy__body') ||
      document.querySelector('#mainContent > div:first-child > div:nth-child(2)')
    );
  }

  function mergeParagraphIntoPrevious(paragraph, previousMatchText) {
    var previousParagraph = paragraph ? paragraph.previousElementSibling : null;

    if (
      !previousParagraph ||
      !previousParagraph.matches('p') ||
      normalizeText(previousParagraph.textContent).indexOf(previousMatchText) === -1
    ) {
      return;
    }

    if (previousParagraph.textContent.trim() !== '' && paragraph.textContent.trim() !== '') {
      previousParagraph.appendChild(document.createTextNode(' '));
    }

    while (paragraph.firstChild) {
      previousParagraph.appendChild(paragraph.firstChild);
    }

    paragraph.remove();
  }

  function mergeSectionParagraphIntoPrevious(section, targetText, previousMatchText) {
    var paragraphs = section.contentNodes.filter(function (node) {
      return node.matches && node.matches('p');
    });
    var targetParagraph = paragraphs.find(function (paragraph) {
      return normalizeText(paragraph.textContent).indexOf(targetText) === 0;
    });
    var targetIndex = paragraphs.indexOf(targetParagraph);
    var previousParagraph = targetIndex > 0 ? paragraphs[targetIndex - 1] : null;

    if (
      !targetParagraph ||
      !previousParagraph ||
      normalizeText(previousParagraph.textContent).indexOf(previousMatchText) === -1
    ) {
      return;
    }

    if (previousParagraph.textContent.trim() !== '' && targetParagraph.textContent.trim() !== '') {
      previousParagraph.appendChild(document.createTextNode(' '));
    }

    while (targetParagraph.firstChild) {
      previousParagraph.appendChild(targetParagraph.firstChild);
    }

    section.contentNodes = section.contentNodes.filter(function (node) {
      return node !== targetParagraph;
    });

    targetParagraph.remove();
  }

  function collectH3SectionNodes(heading) {
    var nodes = [];
    var currentNode = heading.nextElementSibling;

    while (currentNode && !currentNode.matches('h3')) {
      nodes.push(currentNode);
      currentNode = currentNode.nextElementSibling;
    }

    return nodes;
  }

  function createIcon(className) {
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var horizontalPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    icon.setAttribute('class', className);
    icon.setAttribute('width', '22');
    icon.setAttribute('height', '22');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', 'currentColor');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');

    horizontalPath.setAttribute('fill-rule', 'evenodd');
    horizontalPath.setAttribute('clip-rule', 'evenodd');
    horizontalPath.setAttribute('d', 'M21 13L3 13L3 11L21 11L21 13Z');
    icon.appendChild(horizontalPath);

    if (className.indexOf('accordion__icon--plus') !== -1) {
      var verticalPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      verticalPath.setAttribute('fill-rule', 'evenodd');
      verticalPath.setAttribute('clip-rule', 'evenodd');
      verticalPath.setAttribute('d', 'M11 21L11 3L13 3L13 21L11 21Z');
      icon.appendChild(verticalPath);
    }

    return icon;
  }

  function createAccordionItem(section, index) {
    var item = document.createElement('div');
    var header = document.createElement('div');
    var button = document.createElement('button');
    var label = document.createElement('span');
    var toggle = document.createElement('span');
    var toggleButton = document.createElement('span');
    var content = document.createElement('div');
    var titleId = 'shipping-policy-accordion-title-' + (index + 1);
    var contentId = 'shipping-policy-accordion-content-' + (index + 1);

    item.className = 'policy-accordion__item accordion__item js-accordion-item';
    header.className = 'accordion__header';

    button.className = 'btn-plain w-100 js-accordion-trigger d-flex middle-xs p-relative p-zero c-pointer gap-12';
    button.id = titleId;
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', contentId);

    label.className = 'h5 m-zero flex-1 ta-left';
    label.textContent = section.heading.textContent.trim();

    toggle.className = 'accordion__toggle zi-1 d-flex';
    toggleButton.className = 'zi-1 btn btn-small btn-icon';
    toggleButton.appendChild(createIcon('accordion__icon--plus p-absolute'));
    toggleButton.appendChild(createIcon('accordion__icon--minus p-absolute'));
    toggle.appendChild(toggleButton);

    content.className = 'policy-accordion__content js-accordion-content accordion-content mb-0 rte';
    content.id = contentId;
    content.setAttribute('role', 'region');
    content.setAttribute('aria-describedby', titleId);
    content.setAttribute('tabindex', '-1');
    content.style.maxHeight = '0';

    if (isAccordionStartText(normalizeText(section.heading.textContent))) {
      mergeSectionParagraphIntoPrevious(
        section,
        additionalProductionTimeText,
        additionalProductionTimePreviousText
      );
    }

    section.heading.remove();
    section.contentNodes.forEach(function (node) {
      content.appendChild(node);
    });

    button.appendChild(label);
    button.appendChild(toggle);
    header.appendChild(button);
    item.appendChild(header);
    item.appendChild(content);

    return item;
  }

  function toggleAccordionItem(trigger, isOpen) {
    var content = document.getElementById(trigger.getAttribute('aria-controls'));

    if (!content) {
      return;
    }

    trigger.setAttribute('aria-expanded', String(isOpen));
    trigger.classList.toggle('open', isOpen);
    content.classList.toggle('open', isOpen);
    content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
  }

  function bindAccordion(accordion) {
    accordion.querySelectorAll('.js-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        toggleAccordionItem(trigger, trigger.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function transformShippingAccordions(policyBody) {
    var h3Headings;
    var staticHeadingIndex;
    var startHeadingIndex;
    var sections = [];
    var accordion;

    if (policyBody.dataset.shippingPolicyAccordionTransformed === 'true') {
      return;
    }

    h3Headings = Array.prototype.slice.call(policyBody.querySelectorAll('h3'));
    staticHeadingIndex = h3Headings.findIndex(function (heading) {
      return normalizeText(heading.textContent) === staticHeadingText;
    });
    startHeadingIndex = h3Headings.findIndex(function (node, index) {
      if (staticHeadingIndex !== -1 && index <= staticHeadingIndex) {
        return false;
      }

      return isAccordionStartText(normalizeText(node.textContent));
    });

    if (startHeadingIndex === -1 && staticHeadingIndex !== -1) {
      startHeadingIndex = staticHeadingIndex + 1;
    }

    if (startHeadingIndex === -1 || startHeadingIndex >= h3Headings.length) {
      return;
    }

    h3Headings.slice(startHeadingIndex).forEach(function (node) {
      sections.push({
        heading: node,
        contentNodes: collectH3SectionNodes(node)
      });
    });

    if (sections.length === 0) {
      return;
    }

    accordion = document.createElement('div');
    accordion.className = 'policy-accordion';
    sections[0].heading.insertAdjacentElement('beforebegin', accordion);

    sections.forEach(function (section, index) {
      accordion.appendChild(createAccordionItem(section, index));
    });

    bindAccordion(accordion);
    policyBody.dataset.shippingPolicyAccordionTransformed = 'true';
  }

  function markStaticHeading() {
    var policyBody = getPolicyBody();

    if (!policyBody) {
      return;
    }

    var headings = Array.prototype.slice.call(policyBody.querySelectorAll(headingSelector));
    var paragraphs = Array.prototype.slice.call(policyBody.querySelectorAll('p'));
    var lastUpdated = paragraphs.find(function (paragraph) {
      return normalizeText(paragraph.textContent).indexOf(lastUpdatedText) === 0;
    });
    var productionTiming = paragraphs.find(function (paragraph) {
      return normalizeText(paragraph.textContent).indexOf(productionTimingText) === 0;
    });
    var staticHeading = headings.find(function (heading) {
      return normalizeText(heading.textContent) === staticHeadingText;
    });

    if (lastUpdated) {
      lastUpdated.classList.add('policy-last-updated');
    }

    if (productionTiming) {
      mergeParagraphIntoPrevious(productionTiming, productionTimingPreviousText);
    }

    if (!staticHeading) {
      transformShippingAccordions(policyBody);
      return;
    }

    staticHeading.classList.add('policy-static-heading');
    staticHeading.dataset.policyStaticHeading = 'true';

    transformShippingAccordions(policyBody);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markStaticHeading);
  } else {
    markStaticHeading();
  }
})();
